import { listingPlansDeTravailMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listingPlansDeTravailMock];

export const plansDeTravailMock: SlugPage = {
  ...pageBase({
    title: 'Plans de travail',
    type: 'plans-de-travail',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
